<template>
  <div style="width:1020px; margin:20px auto">

    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="活动名称">
        <el-input v-model="form.title"></el-input>
      </el-form-item>

      <el-form-item label="活动形式">
        <!-- <my-editor v-model="form.content"></my-editor> -->
      </el-form-item>


      <div>
        <!-- <myquill v-model="form.content"></myquill> -->
      </div>


      <el-form-item>
        <el-button type="primary" >提交</el-button>
        <el-button @click="goback">取消</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script >
import axios from 'axios'

export default ({
  name: 'editor',
  components: {
  },
  data() {
    return {
      id:0,
      form: {
        title: '',
        content: ''
      }
    }
  },
  methods: {
    onSubmit() {
      console.log(this.form);

      let params = {
        content: this.form.content,
        uid: 21,
        token: '339c3ee5d33caaa31497cc8016aa4283',
        title: this.form.title
      }
      console.log(params);
      axios.post('/api/Question/addvueQuestion', params, {
        // headers: {
        //   'Content-Type': 'application/x-www-form-urlencoded'
        // },
      }).then(this.getSubmitSucc);

    },
    getSubmitSucc(res) {
      res = res.data
      console.log(res);
      if (res.Code == 200) {
        this.form = {
          title: '',
          content: ''
        }
        this.$message({
          message: '添加成功!',
          type: 'success'
        });
      } else {
        this.$message.error('失败了哦');
      }
    },
    loadingData() {
      let params = {
        uid: 21,
        token: '339c3ee5d33caaa31497cc8016aa4283',
        id: this.id
      }
      console.log(params);
      axios.post('/api/Question/getQuestionByID', params, {
        // headers: {
        //   'Content-Type': 'application/x-www-form-urlencoded'
        // },
      }).then(this.loadingDataSucc);
    },
    loadingDataSucc(res){
res = res.data
      console.log(res);
      if (res.Code == 200 || res.Code==0) {
        this.form = {
          title: res.title,
          content: res.content
        }
      }
    },
    goback() {
      this.$router.go(-1);
    }
  },
  mounted() {
    const id = this.$route.params.id;
    console.log(id);
    this.id=id;
    if(id>0){
      this.loadingData();
    }
  }
})
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/editor/editor.vue